/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { defaultLanguageEnumSchema } from "./defaultLanguageEnumSchema.ts";

export const supportedLanguagesEnumSchema = defaultLanguageEnumSchema.describe(
	"* `ru` - Русский\n* `en` - Английский\n* `es` - Испанский\n* `ar` - Арабский\n* `zh` - Китайский\n* `kk` - Казахский\n* `hy` - Армянский\n* `ka` - Грузинский\n* `az` - Азербайджанский\n* `uz` - Узбекский",
);
